<template>
    <v-layout
      row
      pt-2
    >
<!--      <v-flex xs12 >-->
<!--        <div class="divInTripPlanning">-->
<!--          <v-layout-->
<!--            row-->
<!--            wrap-->
<!--            justify-space-between-->
<!--          >-->
<!--              <v-flex xs2>-->

<!--              </v-flex>-->
<!--            <v-flex xs2>-->
<!--              <v-dialog-->
<!--                ref="dialog"-->
<!--                v-model="modal"-->
<!--                :return-value.sync="date"-->
<!--                persistent-->
<!--                lazy-->
<!--                full-width-->
<!--                width="290px"-->
<!--              >-->
<!--                <template v-slot:activator="{ on }">-->
<!--                  <v-text-field-->
<!--                    prepend-icon="event"-->
<!--                    v-model="date"-->
<!--                    label="Check-out"-->
<!--                    readonly-->
<!--                    v-on="on"-->
<!--                  ></v-text-field>-->
<!--                </template>-->
<!--                <v-date-picker v-model="date" scrollable>-->
<!--                  <v-spacer></v-spacer>-->
<!--                  <v-btn flat color="primary" @click="modal = false">Cancel</v-btn>-->
<!--                  <v-btn flat color="primary" @click="$refs.dialog.save(date)">OK</v-btn>-->
<!--                </v-date-picker>-->
<!--              </v-dialog>-->
<!--            </v-flex>-->

<!--              <v-btn-->
<!--                color="primary"-->
<!--                round-->
<!--                class="buttonInSearchActivityStroke"-->
<!--                large-->
<!--              >-->
<!--                {{$translate('SEARCH')}}-->
<!--              </v-btn>-->
<!--          </v-layout>-->
  <v-flex xs7 mb-3 style=" margin-bottom: 5em !important;">
      <v-form class="formMET">
        <v-layout row align-center justify-center>
          <v-flex
            xs12
            pa-2
            style="border-radius: 9px;"
            :style="`background-color: ${$vuetify.theme.secondary}`"
          >
            <v-layout row ml-1 mr-1 justify-space-between>
              <v-flex xs3>
                <v-dialog
                  ref="dialog1"
                  v-model="modal1"
                  :return-value.sync="date1"
                  persistent
                  lazy
                  full-width
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      prepend-icon="event"
                      v-model="date1"
                      label="Check-in"
                      readonly
                      v-on="on"
                      dark
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    header-color="`background-color: ${$vuetify.theme.secondary}`"
                    v-model="date1"
                    scrollable
                    :style="`background-color: ${$vuetify.theme.secondary}`"
                  >
                    <v-spacer></v-spacer>
                    <v-btn flat white style="color:white" @click="modal1 = false">Cancel</v-btn>
                    <v-btn flat white style="color:white" @click="$refs.dialog1.save(date1)">OK</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-flex>
              <v-flex xs3>
                <v-dialog
                  ref="dialog"
                  v-model="modal2"
                  :return-value.sync="date2"
                  persistent
                  lazy
                  full-width
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      prepend-icon="event"
                      v-model="date2"
                      label="Check-out"
                      readonly
                      v-on="on"
                      dark
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    header-color="`background-color: ${$vuetify.theme.secondary}`"
                    v-model="date2"
                    scrollable
                    :style="`background-color: ${$vuetify.theme.secondary}`"
                  >
                    <v-spacer></v-spacer>
                    <v-btn flat white style="color:white" @click="modal2 = false">Cancel</v-btn>
                    <v-btn flat white style="color:white" @click="$refs.dialog.save(date2)">OK</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-flex>
              <v-btn
                color="primary"
                round
                class="buttonInSearchActivityStroke"
                large
              >{{$translate('SEARCH')}}</v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-form>
  </v-flex>
          <v-layout column wrap>
            <v-flex xs9>
              <v-card
                flat
                v-if="showCalendar"
                elevation="3"
                class="grey lighten-2 rounded-card ml-1"
                style="margin-bottom: 1em !important; margin-top: -0.5em;"
              >
                <!-- card panel for the calendar -->
                <v-card
                  id="get
                  EventDetails"
                  flat
                  v-for="(eventData, key) in paginatedCalendar"
                  :key="key"
                >
                  <v-layout
                    @click="getBatches($store.getters.getClickedTime, eventData)"
                    style="margin: 0.5em;"
                  >
                    <!-- If the image data is empty it has a no image picture -->
                    <img
                      v-if="eventData.Picture !== 'NULL'"
                      aspect-ratio="1"
                      class="pa-1 calendarImage"
                      :src="eventData.Picture"
                    >
                    <img
                      v-else
                      class="calendarImage"
                      aspect-ratio="1"
                      src="https://cdn3.iconfinder.com/data/icons/abstract-1/512/no_image-512.png"
                    >
                    <v-layout class="ml-2 column">
                      <h3 :style="`color: ${$vuetify.theme.primary}`">{{eventData.Name}}</h3>
                      <p
                        class="suggestionsTime"
                        v-if="eventData.BatchFrequency > 0"
                      >{{eventData.StartTime}} - {{eventData.EndTime}}, {{$translate('EVENT_STARTS_EVERY')}} {{(eventData.BatchFrequency / 60).toFixed(0)}} {{$translate('MINUTES')}}</p>
                      <p
                        class="suggestionsTime"
                        v-if="eventData.BatchFrequency > 0"
                      >{{$translate('EVENT_DURATION')}} {{(eventData.Duration / 60).toFixed(0)}} {{$translate('MINUTES')}}</p>
                      <p
                        class="suggestionsTime"
                        v-else
                      >{{eventData.StartTime}} - {{eventData.EndTime}}, {{$translate('EVENT_DURATION')}} {{(eventData.Duration / 60).toFixed(0)}} {{$translate('MINUTES')}}</p>
                      <p>Date: {{eventData.eventDate}}</p>
                    </v-layout>
                    <v-layout align-end justify-end row>
                      <v-list-tile-action>
                        <v-btn
                          color="secondary"
                          round
                          class="mt-2"
                          large
                          @click="getBatches($store.getters.getClickedTime, eventData)"
                        >{{$translate('BOOK')}}</v-btn>
                      </v-list-tile-action>
                    </v-layout>
                  </v-layout>
                  <v-card
                    flat
                    v-if="extraEventInfo && chosenEventId == eventData.EventId && eventData.BatchGroupId == chosenBatchGroupId && chosenDate == eventData.eventDate"
                  >
                    <v-layout class="calendar-expansion-content" ma-2 row>
                      <v-card-text class="lighten-3">{{eventDescription}}</v-card-text>
                      <!-- If the image data is empty it has a no image picture -->
                      <img
                        :aspect-ratio="14/9"
                        class="suggestionsImage"
                        v-if="!eventPicture == ''"
                        :src="eventPicture"
                      >
                      <img
                        :aspect-ratio="14/9"
                        class="suggestionsImage"
                        v-else
                        src="https://cdn3.iconfinder.com/data/icons/abstract-1/512/no_image-512.png"
                      >
                    </v-layout>
                  </v-card>
                </v-card>
              </v-card>
              <v-layout justify-end row style="margin-bottom: 10em;">
                <v-pagination
                  class="pagination mt-0"
                  total-visible="5"
                  v-model="page"
                  :length="nPages"
                  @input="selectPage"
                  @next="nextPage"
                  @previous="previousPage"
                ></v-pagination>
              </v-layout>
            </v-flex>
          </v-layout>
       <v-layout row justify-center fill-height>
       <v-dialog v-model="availableDialog" persistent fullscreen hide-overlay transition="dialog-bottom-transition">
         <v-card v-if="!orderOverview" class="elevation-0">
           <v-toolbar class="availableV-Card" color="primary" dark>
             <v-btn icon dark @click="availableDialog = false">
               <v-icon>close</v-icon>
             </v-btn>
             <v-toolbar-title>Order details</v-toolbar-title>
           </v-toolbar>
          <v-layout row>
            <v-card class="v-card--flat containerForOrder">
              <template>
                <v-flex xs12 d-flex>
                  <h3>Select the time you want to visit the activity: </h3>
                  <v-select :items="allBatches" v-model="currentBatch"  item-text="TotalTime" return-object persistent-hint label="Select the time range" solo></v-select>
                </v-flex>
                <v-flex v-if="currentBatch.hasOwnProperty('PriceCategories')" class="mt-4" xs12 d-flex>
                  <h3>Select the tickets for your visit: </h3>
                </v-flex>
                <v-flex v-if="currentBatch.hasOwnProperty('PriceCategories')" xs12 d-flex>
                  <v-layout column>
                    <template v-for="(item, index) in currentBatch.PriceCategories">
                      <v-card-text :key="index">
                        <v-spacer></v-spacer>
                        <v-layout row>
                          <v-layout column>
                            <h2>{{item.Name}}</h2>
                            <p>{{item.Description}}</p>
                          </v-layout>
                          <v-layout row>
                            <v-layout align-end justify-start>
                              <p>€ {{item.Price}}</p>
                            </v-layout>
                            <v-layout align-start justify-end row >
                              <v-text-field
                                @input="checkTheOrder(item)"
                                v-model="item.Amount"
                                class="countTickets"
                                type="number"
                                min="0"
                                max="10"
                                placeholder="0"
                                max-lenght="2">
                              </v-text-field>
                            </v-layout>
                          </v-layout>
                        </v-layout>
                      </v-card-text>
                    </template>
                  </v-layout>
                </v-flex>
              </template>
            </v-card>
            <v-card class="sidebarForOrder">
              <v-layout v-if="!selectedTicket" column class="man" justify-center>
                <v-icon x-large>emoji_people</v-icon>
                <h2 style="text-align: center">{{$translate('NOT_CHOSEN')}}</h2>
              </v-layout>
              <v-layout column>
                <template v-for="(item, index) in order">
                  <v-flex xs12 class="productCard" :key="index">
                    <p style="float:left">{{item.Name}} €{{item.Price}}</p>
                    <b style="float:right">{{item.Amount}}x</b>
                    <p class="ds1" style="float:left">{{item.Description}}</p>
                    <p style="float:left">Subtotal:</p>
                    <b style="float:right">€{{item.Price * item.Amount}}</b>
                  </v-flex>
                  <hr>
                </template>
              </v-layout>
              <v-layout justify-center>
                <!-- it belongs to the v-btn below! :disabled="!currentBatch.hasOwnProperty('PriceCategories')"-->
                <v-btn
                  v-if="selectedTicket"
                  color="primary"
                  round
                  class="bookBatchButton"
                  large
                  @click="bookBatch()"
                >{{$translate('BOOK')}}</v-btn>
              </v-layout>
            </v-card>
          </v-layout>
         </v-card>
         <v-card v-else class="transparent elevation-0">
                     <v-layout column align-end>
             <v-card class="availableV-Card">
               <v-toolbar color="primary" dark>
                 <v-toolbar-title>Order overview</v-toolbar-title>
               </v-toolbar>
               <template>
                 <v-flex xs12 d-flex>
                   <h3>Your order id: {{userOrder.OrderId}}</h3>
                 </v-flex>
                 <v-flex xs12 d-flex>
                  <template v-for="(item, index) of userOrder.Order">
                    <v-card
                      class="tripDetail elevation-0"
                      :key="index"
                    >
                    <v-layout row>
                      <v-avatar>
                        <img v-if="!item.Picture == ''" :src="item.Picture">
                        <img
                          v-else
                          src="https://cdn3.iconfinder.com/data/icons/abstract-1/512/no_image-512.png"
                        >
                      </v-avatar>
                      <v-card-text>
                        <h4>{{ item.Name }}</h4>
                        <p class="orderText">{{item.StartDate}}, {{item.StartTime}} - {{item.EndTime}}</p>
                        <p class="orderText">{{item.PriceCategoryDescription}}, {{item.GroupSize}}</p>
                        <v-layout justify-end align-end>
                        <p>Activity Price: {{item.ActivityTotalPrice}}</p>
                        </v-layout>
                        <v-divider></v-divider>
                      </v-card-text>
                      </v-layout>
                    </v-card>
                  </template>
                 </v-flex>
                 <v-spacer></v-spacer>
                 <v-flex class="mr-2" xs12 d-flex>
                   <v-layout justify-end align-end>
                   Total price: {{userOrder.OrderTotalPrice}}
                   </v-layout>
                 </v-flex>
               </template>
             <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              round
              class="text-capitalize"
              color="primary"
              @click="cancelOrder()"
            >
              {{$translate('LINDA_CANCEL_ORDER')}}
            </v-btn>
            <v-btn
              round
              class="text-capitalize"
              color="primary"
              @click="confirmOrderLoading()"
            >
              {{$translate('LINDA_CONFIRM_ORDER')}}
            </v-btn>
          </v-card-actions>
             </v-card>
           </v-layout>
         </v-card>
       </v-dialog>
       </v-layout>
      <div class="text-xs-center">
        <v-dialog v-model="showLoading" persistent max-width="390">
        <v-card class="confirmLoadingDialog">
          <v-layout column justify-center align-start>
            <v-card-title class="headline">Order info</v-card-title>
            <v-card-text>
              <p class="setFontSize" :style="getFontProperty()">Your order has been received.</p>
              <p
                class="setFontSize"
                v-if="userOrder.OrderTotalPrice !== '0'"
                :style="getFontProperty()"
              >You will be automatically redirected to the payment page</p>
              <p
                v-else
                class="setFontSize"
                :style="getFontProperty()"
              >You will be automatically redirected to your appointments</p>
            </v-card-text>

            <v-progress-linear :indeterminate="true"></v-progress-linear>
          </v-layout>
        </v-card>
      </v-dialog>
       <v-dialog
            width="500"
            persistent
            v-model="freeTripDialog"
          >
            <v-card>
              <v-card-title
                class="headline grey lighten-2"
                primary-title
              >
                Order saved
              </v-card-title>
              <v-card-text>
                The order is saved. you will be returned to the 'My activities' page.
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
        </v-dialog>
       <v-dialog
         width="500"
         persistent
         v-model="emptyInputs"
       >
         <v-card>
           <v-card-title
             class="headline grey lighten-2"
             primary-title
           >
             Nothing filled in
           </v-card-title>
           <v-card-text>
             The input fields are empty.
           </v-card-text>
           <v-divider></v-divider>
           <v-card-actions>
             <v-spacer></v-spacer>
             <v-btn @click="emptyInputs = false">Close</v-btn>
           </v-card-actions>
         </v-card>
       </v-dialog>
     </div>
  </v-layout>
</template>

<script>
  import PearlCalendar from "@/components/PearlCalendar";
  import appConfig from "../../config/app_config.js";
  import * as dssRequest from "../api/dssRequest";
  import { mapGetters } from "vuex";
  import BaseObject from "../objects/BaseObject";
  import BaseComponent from "./base/BaseComponent.vue";
  import { ui_helpers } from "../shared/ui_helpers.js";
  import Sortable from "sortablejs";
  import OperationalScreen_MapQuadrant from "./OperationalScreen/OperationalScreen_MapQuadrant";
  import _ from "lodash";
  import HotelDatePicker from 'vue-hotel-datepicker';

  export default {
    extends: BaseComponent,
    components: {
      OperationalScreen_MapQuadrant,
      PearlCalendar,
      HotelDatePicker,
    },
    mixins: [ui_helpers],

    name: "TripPlanning",
    props: {
      properties: {},
      eventDate: "",
      editMode: Boolean
    },

    computed: {
      ...mapGetters({
        _webStep: "getWebStepId",
        _tripForm: "getTripForm",
        _discountCards: "getDiscountCards",
        _accountInfo: "getAccountInfo"
      }),
      switchMapView() {
        return !this.mapView ? "Show Map" : "Show Timeline";
      },
      openCloseTour() {
        return !this.tourOpened ? "Open tour" : "Close tour";
      },
    },

    watch: {
      calendarItems: function(next, to) {
        this.page = 1;
        this.recountPage();
      },
      timeLinePoints: function(newVal, oldVal) {
        console.log("timelinepoints at watch", newVal, oldVal)
        console.log("edit mode on time line points", this.editMode)
        if (this.editMode == true) {
          if (oldVal.length !== 0 && (newVal.length !== oldVal.length)) {
            this.saveButton = true;
          } else {
            this.saveButton = false;
          }
        } else {
          if (newVal.length !== oldVal.length) {
            this.saveButton = true;
          } else {
            this.saveButton  = false;
          }
        }
      },
      plannedActivities: function(newVal, oldVal) {
        var firstPlusButton = {
          Plus: true,
          Text: "Add an activity",
          StartTime: this._tripForm.ArrivalTime,
          EndTime: this._tripForm.DepartureTime
        };

        var activityCount = 0;

        this.plannedActivities.forEach((activity, i) => {
          if (activity.Type == "Standard" || activity.Type == 'Tour') {
            activityCount++;
          }
        });

        console.log("activity COUNT", activityCount)
        if (activityCount >= this.maxPrebooks || this.planningDone == true) {

          console.log(" Planning done or max pre book ? ", newVal, this.planningDone, this.maxPrebooks)
          // Trip full, no more plus buttons
          this.timeLinePoints = [];
          this.plannedActivities.forEach(activity => {
            //Set travelPoint Type for current activity
            if (activity.Type == "Walking" || activity.Type == "Relay") {
              activity.TransportType = "Walking";
            }
            if (activity.Name !== 'Start' && activity.Name !== 'End') {
              this.timeLinePoints.push(activity);
            }
            if (activity.Name == 'Start' ) {
              this._tripForm.ArrivalTime = activity.StartTime
            }
            if (activity.Name == 'End' ) {
              this._tripForm.DepartureTime = activity.EndTime

            }
          });
        } else {
          if (this.plannedActivities.length > 0) {
            //First plus button
            this.timeLinePoints = [firstPlusButton];
          } else {
            //Empty trip
            console.log("empty");
            this.timeLinePoints = [];
          }

          //Loop through activities
          this.plannedActivities.forEach((activity, i) => {
            console.log("activity", activity)
            //Set last POINT endTime to this ACTIVITY startTime
            this.timeLinePoints[this.timeLinePoints.length - 1].EndTime =
              activity.StartTime;

            //Set travelPoint Type for current activity
            if (activity.Type == "Walking" || activity.Type == "Relay") {
              //Set last POINT endTime to this ACTIVITY startTime
              this.timeLinePoints[
              this.timeLinePoints.length - 1
                ].EndTime = this.plannedActivities[i + 1].StartTime;

              activity.TransportType = "Walking";
              if (activity.Name !== 'Start' && activity.Name !== 'End') {
                this.timeLinePoints.push(activity);
              }
            } else {
              if (activity.Name !== 'Start' && activity.Name !== 'End') {
                this.timeLinePoints.push(activity);
              }

              //configure new Plus button and add to timeLine
              var newPlusButton = Object.assign({}, firstPlusButton);
              newPlusButton.StartTime = activity.EndTime;
              newPlusButton.EndTime = this._tripForm.DepartureTime;
              if (activity.Name !== 'Start' && newPlusButton.StartTime !== newPlusButton.EndTime) this.timeLinePoints.push(newPlusButton);
            }
          });
        }
        this.showActivityMarkers();
      }
    },

    data: () => ({
      //Orderdetails
      selectedTicket: false,

      //datepicker
      date1: new Date().toISOString().substr(0, 10),
      menu1: false,
      modal1: false,
      date2: new Date().toISOString().substr(0, 10),
      menu2: false,
      modal2: false,
      //Calendar
      order: [],
      emptyInputs: false,
      showLoading: false,
      freeTripDialog: false,
      userOrder: {},
      orderOverview: false,
      currentBookingEvent: {},
      currentBatch: {},
      allTickets: 0,
      priceCategories: {},
      extraEventInfo: false,
      showCalendar: true,
      paginatedCalendar: [],
      page: 1,
      nPages: 1,
      elementXpage: 4,
      calendarItems: [],
      page: 1,
      nPages: 1,
      firstDate: "",
      secondDate: "",
      //to delete
      allBatches: [],
    //timeline points = Activty points + Travel points + Plus buttons
    totalPrice: 0,
    ticketDialog: false,
    availableDialog: false,
    pictureOfSelectedEvent:"",
    selectingCalendar: {},
    eventDescription: '',
    calendarDialog: false,
    event: {},

    tourOpened: false,
    alternativeFailed: false,
    noMoreWishList: false,
    saveButton: false,
    timeLinePoints: [],
    deleteYourActivities: false,
    deleteYourTrip: false,
    plannedActivities: [],
    maxPrebooks: 2,
    eventDetail: {},
    eventDetailDialog: false,
    alternativesDialog: false,
    alternativeActivities: [],
    currentActivity: "testActivity",
    planningDone: false,
    showLoading: false,
    selectedEvent: {},
    DescriptionOfEventDialog: false,

    deleteLoading: false,
    gapStart: "",
    gapEnd: "",
    mapView: false,

    locationProps: {
      component: "OperationalScreen_MapQuadrant",
      componentId: "OperationalScreen_MapQuadrant_MAPOFINCIDENT",
      fullSize: true,
      hidden: false,
      location: {},
      mainMap: false,
      name: "OperationalScreen_MapQuadrant_NPSTNJ",
      params: {
        location: {
          latitude: "53.080380",
          longitude: "4.800127",
          polyline: "",
          waypoints: ""
        }
      },
      pinned: true,
      position: {
        x: 0,
        y: 0
      },
      profile: {
        connect: false,
        default: false,
        landing: true,
        relink: true,
        style: {
          height: "big"
        }
      },
      height: "height: 70vh; max-width: 50vw; width: 50vw;",
      showBackButton: true,
      showToolbar: false,
      signalObjectMap: [],
      tag: "",
      interaction: true,
      tooltip: false,
      rightClick: false,
      includeCenterPoint: false,
      clickEvent: true,
      zoomControls: false,
    },

    }),
    created() {
      window.EventBus.listen("selectActivity", this.selectActivity);
    },
    beforeDestroy() {
      window.EventBus.removeListener("selectActivity", this.selectActivity);
    },
    mounted() {
      if(!_.isEmpty(this.$store.getters.getCalendar)){
        this.createCalendarArrayOfItems(this.$store.getters.getCalendar)
      }
      this.event = this.$store.getters.getEventData
      window.scrollTo({
        top: 0,
        left: 0,
      });
    },

    directives: {},

    methods: {
      checkTheOrder(item){
        if(!_.isEmpty(this.order)){
          this.order.forEach((e => {

            if(e.Id == item.Id){
              if(item.Amount == '0'){
                this.order.splice(this.order.indexOf(e))
                if(_.isEmpty(this.order)){
                  this.selectedTicket = false;
                }
              }
              else {
                e.Amount = item.Amount
              }
            }
          }))
        }
        else {
          this.order.push(item)
          this.selectedTicket = true;
        }
      },
      bookBatch(){
       const tickets = {};
       for (let [key, value] of Object.entries(this.currentBatch.PriceCategories)) {
         if (value.Amount > "0")  {
           Object.assign(tickets,
           {
             [value.Id] :Number(value.Amount)
            })
         }
         else {
           this.emptyInputs = true;
           return
         }
       }
        const payload = {
          StartDate: this.properties.StartDate,
          EventId: Number(this.currentBookingEvent.EventId),
          BatchId: this.currentBatch.BatchId,
          Tickets: tickets
        };
        dssRequest.doRequest(
          response => {
            console.log(
              "The generic call bookBatch was successful",
              response
            );
            this.orderOverview = true;
            this.userOrder = response.data;

          },
          error => {
            console.log(
              "The generic call bookBatch was not successful",
              error
            );
            this.errorDialog = true;
            // Defining the error codes
            if (error.errorMsg !== undefined) this.errorMsg = error.errorMsg;
            if (this.errorMsg == "") this.errorMsg = 'E_00_00';
          },
          "bookBatch",
          this.$store.getters["auth/userName"],
          payload,
          600000,
          false
        );
      },
        getBatches(payloadData, event) {
        this.currentBatch = {};
        this.orderOverview = false;
        this.currentBookingEvent = false;
        this.availableDialog = true;
        payloadData.date = payloadData.date.replace("/", "-");
        const payload = {
          StartDate: "25-03-2020",
          EndDate: "25-03-2020",
          StartTime: payloadData.time,
          EndTime: payloadData.EndTime,
        };
        dssRequest.doRequest(
          response => {
            console.log(
              "The generic call getBatches was successful",
              response
            );
            this.availableDialog = true;
            let recievedBatches = Object.values(response.data.Batches);
            recievedBatches.forEach((e => {
              e.TotalTime = (e.StartTime + " - " + e.EndTime)
            }))
            this.allBatches = recievedBatches;

          },
          error => {
            console.log(
              "The generic call getBatches was not successful",
              error
            );
          },
          "getBatches",
          Number(event.EventId),
          payload
        );
      },
      cancelOrder() {
        const payload = {
          OrderId: this.userOrder.OrderId
        };
        dssRequest.doRequest(
          response => {
            console.log(
              "The generic call cancelOrder was successful",
              response
            );
            this.orderOverview = false;
            this.userOrder = {};
            this.currenBatch = {};
            this.currentBookingEvent = {};
            this.availableDialog = false;
          },
          error => {
            console.log(
              "The generic call cancelOrder was not successful",
              error
            );
          },
          "cancelOrder",
          this.$store.getters["auth/userName"],
          payload
        );
      },
      confirmOrder() {
        const payload = {
          Runtime: true,
          OrderId: this.userOrder.OrderId
        };
      dssRequest.doRequest(
        response => {
          console.log("The call for confirmOrder was successful", response);
          this.showLoading = false;
          if (
            response.data.hasOwnProperty("PaymentId") &&
            response.data.hasOwnProperty("PaymentUrl")
          ) {
            this.$store.commit("setTripFormPaymentId", response.data.PaymentId);
            if (this.userOrder.OrderTotalPrice !== "0") {
              const path = response.data.PaymentUrl;
              window.location = path;
            } else {
              // this.goTo("MainEventInfo");
              // this.$store.commit("setWebStepId", 2);
            }
          } else {
            console.log("confirmed tirp without payment");
             window.location.reload();
          }
        },
        error => {
          console.log("The call for confirmOrder was not successful", error);
          this.userOrder = {};
        },
        "confirmOrder",
       this.$store.getters["auth/userName"],
        payload
      );
      },
      confirmOrderLoading() {
        if(this.userOrder.OrderTotalPrice !== 0) {
          this.showLoading = true;
        } else if (this.userOrder.OrderTotalPrice == 0) {
          this.freeTripDialog = true;
          setTimeout(() => {
            this.freeTripDialog = false;
            this.orderOverview = false;
            this.userOrder = {};
            this.currenBatch = {};
            this.currentBookingEvent = {};
            this.availableDialog = false;
            this.goTo("UserTripList");
          }, 3000);
          return
        }
        setTimeout(() => {
          this.confirmOrder();
        }, 2000);
      },
      selectPage(number) {
        this.recountPage();
      },
      nextPage() {
        this.recountPage();
      },
      previousPage() {
        this.recountPage();
      },
      recountPage() {
        this.nPages = Math.ceil(this.calendarItems.length / this.elementXpage);
        let start = (this.page - 1) * this.elementXpage;
        this.paginatedCalendar = [];
        this.paginatedCalendar = this.calendarItems.filter(
          (e, i) => i >= start && i < start + this.elementXpage
        );
      },
      createCalendarArrayOfItems(data) {
        this.calendarItems = [];
        // Adding the date to the events and saving the events in array calendarItems
        let recievedData = data;
        for (const [key, value] of Object.entries(recievedData)) {
         this.calendarItems.push(value)
        }
      },
      getCurrentDate() {
        //this function is called to get the current day to call the funtion getOnTripCalendar()
        const toTwoDigits = num => (num < 10 ? "0" + num : num);
        let today = new Date();

        let year = today.getFullYear();
        let month = toTwoDigits(today.getMonth() + 1);
        let day = toTwoDigits(today.getDate());
        return day + "-" + month + "-" + year;
      },
      OpenTicketsDialog(item, index){
        this.currentBatch = item;
        this.priceCategories = item.PriceCategories
        this.ticketDialog = true
      },
      closeActivities(){
        this.availableDialog = false
        this.calendarDialog = false
      },
      getOnTripCalendar(day){
        let timeInJSON = JSON.stringify(day)
        let timeInNormalObject = JSON.parse(timeInJSON)

        const payload = {
          StartDate: day,
          EndDate: day
        };
        dssRequest.doRequest(
          response => {
            console.log(
              "The generic call getOnTripCalendar was successful",
              response
            );
            for (let[index, item] of Object.entries(response.data.Calendar)){
              if (!_.isEmpty(response.data.Pictures)) {
                for (let [indexPicture, itemPicture] of Object.entries(
                  response.data.Pictures
                )) {
                  if (item.PictureId == indexPicture) {
                    item.Picture = itemPicture;
                  }
                }
              }
            }
            this.createCalendarArrayOfItems(response.data.Calendar);
            this.calendarDialog = true;
          },
          error => {
            console.log(
              "The generic call getOnTripCalendar was not successful",
              error
            );
          },
          "getOnTripCalendar",
          this.$store.getters["auth/userName"],
          payload
        );
      },
      toggleMapView() {
        // used to toggle mapview on and of
        this.mapView = !this.mapView;
        this.tourOpened = false;
        if (this.mapView) {
          this.showActivityMarkers(600);
        } else {
          this.locationProps.params.location.polyline = "";
        }
      },
      selectActivity(id) {
        // used to highlight the element of the selected activity
        let allActivities = document.getElementsByClassName("activitiesId");
        let allTourActivities = document.getElementsByClassName("tourActivitiesId")
        for (let index = 0; index < allActivities.length; ++index) {
          allActivities[index].classList.remove("teal");
          allActivities[index].classList.remove("accent-2");
        }
        for (let index = 0; index < allTourActivities.length; ++index) {
          allTourActivities[index].classList.remove("teal");
          allTourActivities[index].classList.remove("accent-2");
        }
        let activities = [];
        if (id[0] === "activity") {
          activities = allActivities;
        } else {
          activities = allTourActivities;
        }
        activities[id[1]].classList.add("teal");
        activities[id[1]].classList.add("accent-2");
        activities[id[1]].scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center"
        });

      },
      showActivityMarkers(timeout) {
        // used to show the activity markers on the map view
        let markerActivities = this.plannedActivities.filter(function (el) {
          return el.Type === "Standard" | el.Type === "Tour"
        });
        let clonedMarkerActivities = JSON.parse(JSON.stringify(markerActivities));
        let markerActivitiesFiltered = [];
        clonedMarkerActivities.forEach(function (activity) {
          delete activity.Children;
          delete activity.EventId;
          delete activity.GroupSize;
          delete activity.StartDate;
          delete activity.StartTime;
          delete activity.EndDate;
          delete activity.EndTime;
          delete activity.Location;
          delete activity.Price;
          delete activity.LocationId;
          delete activity.Status;
          delete activity.Data;
          delete activity.BookType;
          delete activity.SeqNr;
          markerActivitiesFiltered.push(activity);
        });
        setTimeout(()=> {
          window.EventBus.fire("pictureMarkers", markerActivitiesFiltered);
        }, timeout);
      },
      setPicture(data) {
        let fileType = ".png";
        return require("../assets/" + data + fileType);
      },
      deleteYourActivity(point){
        this.selectedEvent = point;
        this.deleteYourActivities = true;
      },
      goBack() {
        this.$emit("action", "stopEditing");
        this.$store.commit("setWebStepId", this._webStep - 1);
      },
      goNext() {
        const payload = {
          TripId: this._tripForm.tripId
        };
        dssRequest.doRequest(
          response => {
            console.log("The call for acceptTrip was successful", response);
            if (_.isEmpty(response.data.Order)) {
              this._tripForm.orderList = this.timeLinePoints;
              this.$store.commit("setUserTripOverviewOrderList", {});
              this.$store.commit("setUserTripOverviewOrderList", this._tripForm.orderList);

            }
            else {
              this._tripForm.orderList = response.data.Order;
              this._tripForm.totalPrice = response.data.OrderTotalPrice;
              this._tripForm.orderId = response.data.OrderId;

              this.$store.commit("setUserTripOverview", {});
              this.$store.commit("setUserTripOverview", this._tripForm);
            }

            this.$store.commit("setWebStepId", this._webStep + 1);
            this.$emit("action", "acceptTrip");
          },
          error => {
            console.log("The call for acceptTrip was not successful ", error);
          },
          "acceptTrip",
          this.$store.getters["auth/userName"],
          payload
        );
      },
      getFullTrip() {
        const payload = {
          Runtime: true,
          TripId: this._tripForm.tripId,
          UserId: this.$store.getters["auth/userName"],
          AccountId: this.$store.getters.getCurrentAccountId
        };
        dssRequest.doRequest(
          response => {
            console.log("The generic call getFullTrip was successful", response);
            for(let [index, item] of Object.entries(response.data.Activities)){
              if(item.Name == this.$store.getters.getEventData.Name){
                for (let [innerIndex, innerItem] of Object.entries(item.Children)){
                  if(innerIndex !== 'NrOfChildren'){
                    innerItem.StartTime = Number(innerItem.StartTime.replace(/:/g, '.'))
                    innerItem.EndTime = Number(innerItem.EndTime.replace(/:/g, '.'))
                  }
                }
                this.listOfActivities = item.Children
              }
            }



          },
          error => {
            console.log("The generic call getFullTrip was not successful", error);
          },
          "getFullTrip",
          this.$store.getters["auth/userName"],
          payload
        );
      },
      planActivity(startTime, endTime) {
        console.log("tripId: ", this._tripForm.tripId);

        this.showLoading = true;

        const payload = {
          Runtime: true,
          TripId: this._tripForm.tripId,
          StartDate: this._tripForm.ArrivalDate,
          BookType: 0,
          StartTime: startTime,
          EndDate: this._tripForm.DepartureDate,
          EndTime: endTime
        };
        dssRequest.doRequest(
          response => {
            console.log("The call for bookActivity was successful", response);
            if (response.data.ReturnValue == "success") {
              this.currentActivity = response.data.Activity;
              this.plannedActivities = [];

              if (Object.keys(response.data.Activities).length > 0) {
                console.log("before pushed: ", this.plannedActivities);
                for (let [key, value] of Object.entries(
                  response.data.Activities
                )) {
                  //check status of activity (booked/open?)
                  this.plannedActivities.push(value);
                  // if (value.Status == "Booked") {
                  //   console.log(
                  //     "did push because status of activtiy is: ",
                  //     value.Status, this.plannedActivities
                  //   );
                  //   this.plannedActivities.push(value);
                  // } else if (value.Type == "Walking") {
                  //   console.log(
                  //     "did push because type of activtiy is: ",
                  //     value.Type,
                  //   );
                  //   this.plannedActivities.push(value);
                  // } else {
                  //   console.log(
                  //     "didn't push because status of activtiy is: ",
                  //     value.Status
                  //   );
                  // }
                }
              }
            } else if (response.data.ReturnValue == "No wishlist item") {
              this.planningDone = true;
              this.plannedActivities.push({});
              this.plannedActivities.pop();
              this.noMoreWishList = true
            } else {
              this.currentActivity = response.data.Activity;
              this.alternativesDialog = true;
              this.alternativeActivities = [];

              this.gapStart = startTime;
              this.gapEnd = endTime;

              if (Object.keys(response.data.Alternatives).length > 0) {
                console.log(
                  "alternativeActivities before pushed: ",
                  this.alternativeActivities
                );
                for (let [key, value] of Object.entries(
                  response.data.Alternatives
                )) {
                  console.log(
                    "alternativeActivities pushing: ",
                    this.alternativeActivities
                  );

                  this.alternativeActivities.push(value);
                }
              }
            }
            this.showLoading = false;
          },
          error => {
            console.log("The call for bookActivity was not successful ", error);
            this.showLoading = false;
          },
          "bookActivity",
          this.$store.getters["auth/userName"],
          payload
        );
      },
      bookAlternative(batchGroupId) {
        console.log(
          "CLICKED ALTERNATIVE, batchGroupId: " +
          batchGroupId +
          " gapStart: " +
          this.gapStart +
          " gapEnd: " +
          this.gapEnd
        );

        console.log("tripId: ", this._tripForm.tripId);

        this.showLoading = true;

        const payload = {
          TripId: this._tripForm.tripId,
          BatchGroupId: batchGroupId,
          StartTime: this.gapStart,
          EndTime: this.gapEnd,
          StartDate: this._tripForm.startDate,
          EndDate: this._tripForm.endDate
        };
        dssRequest.doRequest(
          response => {
            console.log("The call for bookAlternative was successful", response);

            //this.currentActivity = response.data.Activity.EventId;

            if (response.data.ReturnValue == "success") {
              this.plannedActivities = [];

              if (Object.keys(response.data.Activities).length > 0) {
                for (let [key, value] of Object.entries(
                  response.data.Activities
                )) {

                  //check status of activity (booked/open?)
                  this.plannedActivities.push(value);
                  // if (value.Status == "Booked") {
                  //   console.log(
                  //     "did push because status of activtiy is: ",
                  //     value.Status, this.plannedActivities
                  //   );
                  //   this.plannedActivities.push(value);
                  // } else if (value.Type == "Walking") {
                  //   console.log(
                  //     "did push because type of activtiy is: ",
                  //     value.Type
                  //   );
                  //   this.plannedActivities.push(value);
                  // } else {
                  //   console.log(
                  //     "didn't push because status of activtiy is: ",
                  //     value.Status
                  //   );
                  // }
                }
              }

              this.alternativesDialog = false;

              console.log("pushed: ", this.plannedActivities);
            } else {
              this.alternativesDialog = true;
              this.alternativeActivities = [];

              if (Object.keys(response.data.Alternatives).length > 0) {
                console.log(
                  "alternativeActivities before pushed: ",
                  this.alternativeActivities
                );
                for (let [key, value] of Object.entries(
                  response.data.Alternatives
                )) {
                  console.log(
                    "alternativeActivities pushing: ",
                    this.alternativeActivities
                  );

                  this.alternativeActivities.push(value);
                }
              }
            }
            this.showLoading = false;
          },
          error => {
            console.log(
              "The call for bookAlternative was not successful ",
              error
            );
            this.showLoading = false;
            if(error.data.ErrorMsg === 'E_TL_014'){
              this.alternativeFailed = true;
              this.alternativesDialog = false
            }
          },
          "bookAlternative",
          appConfig.dss.eventAdminMng,
          payload,
          600000,
          false
        );
      },
      rejectAlternatives(data) {
        const payload = {
          EventId: data.EventId,
          FunctionId: "EventFunctionLibrary::rejectAlternatives",
          TripId: this._tripForm.tripId
        };
        dssRequest.doRequest(
          response => {
            console.log(
              "The call for rejectAlternatives was successful",
              response
            );
            this.alternativesDialog = false;
          },
          error => {
            console.log(
              "The call for rejectAlternatives was not successful ",
              error
            );
          },
          "communicateWithDBLibrary",
          appConfig.dss.eventAdminMng,
          payload
        );
      },
      getEventDetails(eventId,type = "Standard") {
        const payload = {
          EventId: Number(eventId),
          LanguageTagId: this.$store.getters.getUserLanguage
        };

        dssRequest.doRequest(
          response => {
            console.log(
              "The generic call getEventDetails was successful",
              response
            );
            this.eventDetailDialog = true;
            this.eventDetail = response.data;
            if (type !== "Standard") {
              this.eventDetail.Type = type;
            }
            this.eventDescription = response.data.Description
          },
          error => {
            console.log(
              "The generic call getEventDetails was not successful",
              error
            );
            this.eventDetail = error.data;
          },
          "getEventDetailsV2",
          appConfig.dss.eventAdminMng,
          payload
        );
      },
      deleteActivity() {
        this.deleteYourActivities = false
        this.deleteLoading = true
        setTimeout(() => {
          this.deleteLoading = false
        }, 1000);

        const payload = {
          Runtime: true,
          TripId: this._tripForm.tripId,
          EventId: this.selectedEvent.EventId,
          SeqNr: this.selectedEvent.SeqNr
        };

        dssRequest.doRequest(
          response => {
            console.log("The call for cancelBooking was successful", response);

            this.planningDone = false;
            this.plannedActivities = [];

            if (Object.keys(response.data.Activities).length > 0) {
              for (let [key, value] of Object.entries(response.data.Activities)) {

                //check status of activity (booked/open?)
                this.plannedActivities.push(value);
                // if (value.Status == "Booked") {
                //   console.log(
                //     "did push because status of activtiy is: ",
                //     value.Status, this.plannedActivities
                //   );
                //   this.plannedActivities.push(value);
                // } else if (value.Type == "Walking" || activity.Type == "Relay") {
                //   console.log(
                //     "did push because type of activtiy is: ",
                //     value.Type
                //   );
                //   this.plannedActivities.push(value);
                // } else {
                //   console.log(
                //     "didn't push because status of activtiy is: ",
                //     value.Status
                //   );
                // }
              }
            }

          },
          error => {
            console.log(
              "The call for cancelBooking was not successful ",
              error
            );
            if (error.hasOwnProperty('errorMsg') && error.errorMsg == "E_TL_010") {
              this.deleteYourTrip = false;
            }
          },
          "cancelBooking",
          this.$store.getters["auth/userName"],
          payload
        );
      },
      deleteTrip() {
        const payload = {
          Runtime: true,
          TripId: this._tripForm.tripId
        };
        dssRequest.doRequest(
          response => {
            console.log("The call for deleteTrip was successful", response);
            this.$emit("action", "stopEditing");
            this.$store.commit("setWebStepId", 1);
          },
          error => {
            console.log("The call for deleteTrip was not successful ", error);
            if (error.hasOwnProperty('errorMsg') && error.errorMsg == "E_TL_010") {
              this.deleteYourTrip = false;
            }
          },
          "deleteTrip",
          this.$store.getters["auth/userName"],
          payload
        );
      },
      showOnMap(point, type, arrayToFilter) {
        const filterObject = (obj, filter, filterValue) =>
          Object.keys(obj).reduce((acc, val) =>
            (obj[val][filter] === filterValue ? acc : {
                ...acc,
                [val]: obj[val]
              }
            ), {});

        let activitiesWithoutRelays = filterObject(arrayToFilter, "Type", "Relay");
        activitiesWithoutRelays = Object.keys(activitiesWithoutRelays).map(key => activitiesWithoutRelays[key]);
        let index = activitiesWithoutRelays.findIndex(activitie => activitie.StartTime === point.StartTime)
        this.selectActivity([type, index]);
        window.EventBus.fire("showOnMap", [point.Longitude, point.Latitude])
      },
      // showTour(tour) {
      //   // used to open the sub activities in map view and show them on the map
      //   this.tourOpened = !this.tourOpened;
      //   if (!this.tourOpened) {
      //     this.locationProps.params.location.polyline = "";
      //     window.EventBus.fire("generatePolyline", true);
      //     this.showActivityMarkers(0);
      //     window.EventBus.fire("addMarkers");
      //     return
      //   }

      //   let allActivities = document.getElementsByClassName("activitiesId");
      //   let allTourActivities = document.getElementsByClassName("tourActivitiesId")
      //   for (let index = 0; index < allActivities.length; ++index) {
      //     allActivities[index].classList.remove("teal");
      //     allActivities[index].classList.remove("accent-2");
      //   }
      //   for (let index = 0; index < allTourActivities.length; ++index) {
      //     allTourActivities[index].classList.remove("teal");
      //     allTourActivities[index].classList.remove("accent-2");
      //   }
      //   window.EventBus.fire("deleteFeature", "PictureMarker");
      //   // Show polyline
      //   const filterObject = (obj, filter, filterValue) =>
      //     Object.keys(obj).reduce((acc, val) =>
      //       (obj[val][filter] !== filterValue ? acc : {
      //           ...acc,
      //           [val]: obj[val]
      //         }
      //       ), {});

      //   let relaysWithoutActivities = filterObject(tour, "Type", "Relay");
      //   relaysWithoutActivities = Object.keys(relaysWithoutActivities).map(key => relaysWithoutActivities[key]);
      //   let polyline = [];

      //   for (let i=0; i<relaysWithoutActivities.length; i++) {
      //     polyline.push(relaysWithoutActivities[i].Data.Aspect.DataFieldTable.Path);
      //   }
      //   polyline = polyline.join(" ");
      //   this.locationProps.params.location.polyline = polyline;
      //   window.EventBus.fire("generatePolyline");

      //   //show markers
      //   let tourActivitiesWithoutRelays = filterObject(tour, "Type", "Standard");
      //   tourActivitiesWithoutRelays = Object.keys(tourActivitiesWithoutRelays).map(key => tourActivitiesWithoutRelays[key]);
      //   let markers = [];

      //   for (let i=0; i<tourActivitiesWithoutRelays.length; i++) {
      //     markers.push({
      //       lat: tourActivitiesWithoutRelays[i].Latitude,
      //       lng: tourActivitiesWithoutRelays[i].Longitude,
      //     });
      //   }
      //   window.EventBus.fire("addMarkers", markers);
      // }
    }
  };
</script>
<style>
  .small--text {
    font-size: 0.6em;
  }

  .hidden {
    visibility: hidden;
    opacity: 0%;
  }

  .containerTest {
    height: 10em;
  }

  .test {
    height: 7.5em;
    display: table-cell;
    vertical-align: middle;
  }

  .no-alternatives {
    color: grey;
    text-align: center;
  }

  .transportLine {
    position: absolute;
    top: 45px;
    width: 1px;
  }
  .Event_V_Card {
    cursor: pointer;
    position: absolute;
    left:0;
    width:100%;
  }
  .containerTimeline {
    background-color: transparent !important;
    border: none !important;
    max-height: 70vh;

    min-width: 30vw;
    max-width: 30vw;
    overflow-y: auto;
    padding-left: 1vw;
    padding-right: 1vw;
    padding-top: 3px;
    padding-bottom: 3px;
  }
  .v-card--reveal {
    align-items: center;
    bottom: 0;
    justify-content: center;
    background-color: rgba(33,56,203,0.6);

    /*opacity: .6;*/
    position: absolute;
    width: 100%;
  }
  .noTransparency {
    opacity: 1 !important;
  }
  .calendarV-card {
    width: 100%;
    min-height: 36.5em;
  }
  .midVFlex{
    margin: 0 1em;
  }
  .availableV-Card{
    padding-top: 5.5em !important;
  }
  .avatarOfBatches{
    margin: 1em 1em;
  }
  .avatarOfCalenderItems{
    margin: 1em 1em;
    max-width: 48px;
  }
  .countTickets{
    max-width: 2em;
    margin-top: -20em;
  }
  .tripDetail {
  border-radius: 1em;
  border: 2px solid #f2f2f2;
  margin-top: 0.3em;
  margin-right: 0.5em;
  margin-left: 0.5em;
  margin-bottom: 0.4em;
}
.orderText {
  margin-bottom: 0em;
}
 .containerForOrder {
   width: 1200px;
   margin: 0 auto;
   margin-top: 2em;
 }
  .sidebarForOrder {
    height: 100vh;
    width: 20em;
    border-left: black solid !important;
  }
  .bookBatchButton:hover {
    transform: scale(0.8);
  }
  .productCard {
    text-align: center;
    paddadding: 1em;
  }
  .ds1 {
    margin-top: -1em;
    color: #424242;
  }
  .man {
    padding: 1em;
    text-align: center;
  }
  .divInTripPlanning {
    padding-right: 1.5em;
  }
  .formMET {
    height: auto;
    color: white !important;
  }
</style>
